// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c5ZVg","importantInfo":"styles_importantInfo___YBXV"};